module.exports = __webpack_public_path__ + "29e5db8f573f8f3af1271b3d32d51db8.png";